<template>
    <modal :show.sync=show modalClasses="medium-sized-calculator-modal calculator-modal" bodyClasses="p-0" :hide-footer="true" @close="resetForm">
        <h3 slot="header" class="mb-0 font-weight-500">Personal Loan Calculator</h3>

        <div v-loading="loading" class="p-4">
            <ValidationObserver v-slot="{ invalid }" ref="observer">
                <b-form ref="propertyIncomeForm" role="form" @submit.prevent="calculate()">
                    <b-row v-show="tableData.length === 0">
                        <b-col cols="12" md="6">
                            <b-form-group label="Loan Amount">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'loanAmount'"
                                >
                                    <CurrencyInput
                                        v-model="form.loan_amount"
                                        :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                                    />
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="Tenure Year">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'loanMargin'"
                                >
                                    <b-form-input
                                    v-model="form.tenure_year"
                                    type="text"
                                    maxlength="2"
                                    @keydown="preventNonNumericInput"
                                    required
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group label="Interest Rate">
                                <ValidationProvider
                                    v-slot="{ errors }"
                                    :rules="{ required: true }"
                                    :vid="'interestRatePercent'"
                                >
                                    <b-form-input
                                    v-model="form.interest_rate"
                                    type="text"
                                    maxlength="4"
                                    @keydown="preventNonNumericInput"
                                    required
                                    ></b-form-input>
                                    <small v-if="errors[0]" class="text-danger">{{ errors[0] }}</small>
                                </ValidationProvider>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row v-if="tableData.length > 0">
                        <b-col cols="12" md="6">
                            <p>
                                <span class="font-weight-600">Loan Amount:</span>
                                RM {{ form.loan_amount | moneyFormatter }}
                            </p>
                        </b-col>
                        <b-col cols="12" md="6">
                            <p>
                                <span class="font-weight-600">Tenure Year:</span>
                                {{ form.tenure_year }}
                            </p>
                        </b-col>
                        <b-col cols="12" md="6">
                            <p>
                                <span class="font-weight-600">Interest Rate:</span>
                                {{ form.interest_rate }}
                            </p>
                        </b-col>
                        <b-col cols="12" md="6">
                            <p>
                                <span class="font-weight-600">Monthly Instalment:</span>
                                RM {{ tableData[0]['instalment'] }}
                            </p>
                        </b-col>
                        <b-col cols="12" md="6">
                            <p>
                                <span class="font-weight-600">Total Interest:</span>
                                RM {{ totalData.total_interest_charged | moneyFormatter }}
                            </p>
                        </b-col>
                        <b-col cols="12" class="mt-4">
                            <Rule78CalculatorTable  :tableData="tableData" :totalData="totalData" />
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="6" sm="12" class="mx-auto text-center mt-3 pt-2">
                            <b-button type="submit" variant="primary" :disabled="invalid" v-show="tableData.length === 0">Calculate</b-button>
                            <b-button variant="primary" @click.prevent="resetForm">Reset</b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </ValidationObserver>
        </div>
    </modal>
</template>
<script>
import Modal from '@/components/Modal'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import '@/assets/js/formValidations.js'
import CurrencyInput from '@/components/CurrencyInput'
import {
  notifyFunctionMixin,
  helperFunctionMixin,
  axios,
  services,
  getHeader
} from '@/assets/js/httpImports.js'
import Rule78CalculatorTable from '@/views/Calculators/CalculatorsTables/Rule78CalculatorTable'

export default {
    props: {
        rule78_calculator: Boolean
    },
    mixins:[ notifyFunctionMixin, helperFunctionMixin ],
    components: {
        Modal,
        ValidationObserver,
        ValidationProvider,
        CurrencyInput,
        Rule78CalculatorTable
    },
    data() {
        return {
            loading: false,
            form: {
                loan_amount: 100000,
                tenure_year: 5,
                interest_rate: 18
            },
            tableData: [],
            totalData: {}
        }
    },
    computed: {
        show: {
            get() {
                return this.rule78_calculator;
            },
            set(newVal) {
                this.$emit('update:rule78_calculator', newVal);
            },
        },
    },
    methods: {
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        calculate() {
            this.loading = true
            axios.post(services.calculatorNew + '/calculator/personal-loan', this.form, { headers: getHeader() })
            .then(res => {
                this.tableData = res.data.monthly_results;
                this.totalData = res.data.total
                this.loading = false
            })
            .catch(e => {
                this.errorFunction(e)
            })
        },
        resetForm() {
            this.form = {
                loan_amount: 100000,
                tenure_year: 5,
                interest_rate: 18
            }

            this.tableData = []
            this.totalData = {}
        }
    }
}
</script>